class JoyrideStore {
    _setHighlightProps;
    _setPromptProps;
    _setActive;
    registerSetHighlightProps(setHighlightProps) {
        this._setHighlightProps = setHighlightProps;
    }
    registerSetPromptProps(setPromptProps) {
        this._setPromptProps = setPromptProps;
    }
    registerSetActive(setActive) {
        this._setActive = setActive;
    }
    setHighlightProps(props) {
        this._setHighlightProps?.(props);
    }
    setPromptProps(props) {
        this._setPromptProps?.(props);
    }
    setActive(active) {
        this._setActive?.(active);
    }
}
const joyrideStore = new JoyrideStore();
export default joyrideStore;
//# sourceMappingURL=JoyrideStore.js.map